import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export const useRouteLoadingReset = (
    loading: boolean,
    setLoading: (value: boolean) => void
) => {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const prevUrlRef = useRef<string | null>(null);

    useEffect(() => {
        if (!loading) return;

        const currentUrl = `${pathname}?${searchParams.toString()}`;

        if (prevUrlRef.current && prevUrlRef.current !== currentUrl) {
            setLoading(false);
        }

        prevUrlRef.current = currentUrl;
    }, [pathname, searchParams, loading]);
};
